import React from 'react';
import Input from '@creditflowresearch/uilib/Input';
import IconArrowLeft from '@creditflowresearch/uilib/Icon/IconArrowLeft';
import { TIME_INPUT_TYPES_VALUES, TimeInputTypes } from './constants';
import styles from './timePicker.module.scss';
import IconButton from '@creditflowresearch/uilib/IconButton';

interface IProps {
  type: TimeInputTypes,
  increment: (value: number) => void,
  decrement: (value: number) => void,
  onChangeInput: (value: Record<string, number>) => void,
  value: string,
}

const CustomTimeInputSector = ({ type, increment, decrement, onChangeInput, value }: IProps) => {
  return (
    <div className={ styles.timeSector }>
      <IconButton
        icon={ <IconArrowLeft className={ styles.iconTop } /> }
        color="primary"
        className={ styles.sectorButton }
        dataTest={ `timePickerInput${ type }TopButton` }
        onClick={ () => increment(TIME_INPUT_TYPES_VALUES[type]) }
        ariaLabel={ `Increase ${ type }` }
      />
      { /* @ts-ignore */ }
      <Input
        name={ `timePickerInput${ type }` }
        dataTest={ `timePickerInput${ type }Field` }
        inputClassName={ styles.sectorInput }
        maxLength={ 2 }
        value={ value }
        onChange={ (e) => onChangeInput({ [type]: Number(e.target.value) }) }
        isNarrow
        isClearable={ false }
        isErrorMessage={ false }
      />
      <IconButton
        icon={ <IconArrowLeft className={ styles.iconBottom } /> }
        color="primary"
        className={ styles.sectorButton }
        dataTest={ `timePickerInput${ type }BottomButton` }
        onClick={ () => decrement(TIME_INPUT_TYPES_VALUES[type]) }
        ariaLabel={ `Decrease ${ type }` }
      />
    </div>
  );
};

export default CustomTimeInputSector;
